import React from "react";
import { Row, Col } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";

const UserInformations = ({
  recordedBy,
  modifiedBy,
  lifeCycleChangeBy,
  recordedTimeStampData,
  modifiedTimeStampData,
  lifeCycleChangeTimeStampData
}) => {
  return (
    <>
      <Row>
        <Col>
          <strong>{labels.recordedBy}: </strong>
          {recordedBy
            ? `${recordedBy.name} ${recordedBy.lastName} ${labels.atTime} ${recordedTimeStampData}`
            : null}
        </Col>
      </Row>
      <Row>
        <Col>
          <strong>{labels.modifiedBy}: </strong>
          {modifiedBy
            ? `${modifiedBy.name} ${modifiedBy.lastName} ${labels.atTime} ${modifiedTimeStampData}  `
            : null}
        </Col>
      </Row>
      <Row>
        <Col>
          <strong>{labels.lifeCycleChangedBy}: </strong>
          {lifeCycleChangeBy
            ? `${lifeCycleChangeBy.name} ${lifeCycleChangeBy.lastName} ${labels.atTime} ${lifeCycleChangeTimeStampData}  `
            : null}
        </Col>
      </Row>
    </>
  );
};

export default UserInformations;
